import { __assign } from "tslib";
import * as React from 'react';
var MapImpl = React.lazy(function () { return import('../../internal/MapImpl.js'); });
/**
 * Lazy loads a map using leaflet.
 */
export var Map = function (props) { return React.createElement(MapImpl, __assign({}, props)); };
//# sourceMappingURL=index.js.map